import { createFileRoute } from '@tanstack/react-router';
import UploadPage from '@/features/resume-builder/upload';

/** EU-762 RN-07..12 — "Envie seu PDF" (pelo perfil, DEV-483). */
export const Route = createFileRoute('/perfil/curriculo/enviar')({
  component: UploadPage,
});
